import { render, staticRenderFns } from "./InfoReviews.vue?vue&type=template&id=31624ca0&lang=pug"
import script from "./InfoReviews.vue?vue&type=script&lang=ts"
export * from "./InfoReviews.vue?vue&type=script&lang=ts"
import style0 from "./InfoReviews.vue?vue&type=style&index=0&id=31624ca0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports